import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      let slideGroup = this.canvasForms
      .append('g')
      .attr('id', 'CANVAS_SLIDE')
      .attr('transform', `translate(0, 0)`)

      this.chartList.forEach(cht=> {

        let chartGroup = slideGroup
        .append('g')
        .attr('transform', `translate(${cht.cx}, 0)`)

        this.draw_Summary(chartGroup, cht)  

        let canvasChart = chartGroup
        .append('g')
        .attr('transform', `translate(0, ${this.chart.y})`)

        this.set_ChartData(cht)
        this.draw_ChartCanvas(canvasChart)
        this.chart_Controller(canvasChart, cht)
        this.draw_Timeline(canvasChart)
      })

      this.draw_Slide()


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

  }
}